(() => {
  angular
    .module('complianceFrameworkApp.socialMediaCompliance')
    .controller('PoliciesController', PoliciesController);

  /* ngInject */
  function PoliciesController(Flash, sessionService, policiesService) {
    const vm = this;

    vm.hours = [...Array(23).keys()];
    vm.policies = {};
    vm.savePolicies = savePolicies;

    activate();

    function activate() {
      getPolicies();
    }

    function getPolicies() {
      policiesService(sessionService.getAuthToken()).get(response => vm.policies = response);
    }

    function savePolicies() {
      policiesService(sessionService.getAuthToken()).update(vm.policies, _ => {
        Flash.create('success', 'Policies successfully updated.');
      }, _ => {
        Flash.create('danger', 'An error occurred with the submission. Please correct the following errors on the form and resubmit.'); 
      });
    }
  }
})();
